<template>
  <div class="login container-fluid">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <template v-if="success">
            <div class="alert alert-success">
              <h6>Success!</h6>
              <p>We will be reaching out to you soon</p>
            </div>
        </template>
        <template v-if="invalidEmail">
          <div class="alert alert-danger" role="alert">
            Invalid email address
          </div>
        </template>
        <h3>Early Access Signup</h3>
        <label class="form-label">Email</label>
        <input class="form-control" type="text" v-model="email" placeholder="Email"><br />
        <div class="text-center">
          <button class="btn btn-primary" @click="submit">Get Early Access</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { db } from '@/main';

  export default {
    name: 'early access',
    props: {
      path: {
        type: String,
        default: '/'
      },
      messaging: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        email: '',
        success: false,
        invalidEmail: false,
      }
    },
    methods: {
      submit: function() {
        mixpanel.track("click", {"name": "early access button"})
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(String(this.email).toLowerCase())) {
          this.invalidEmail = true;
          return;
        }
        this.invalidEmail = false;
        db.collection('earlyaccess').add({
          email: this.email,
        }).then(() => {
          this.success = true;
          this.email = '';
        })
      }
    }
  }
</script>

<style>
.form-label {
  text-align: left;
}
</style>